// Consists of lowercased letters, digits and hyphens.
// Can not start or end with hyphen.
// Warning: does not forbid consecutive hyphens
export const slugRegex = /^[a-z0-9][a-z0-9-]*[a-z0-9]$/;
